export default __webpack_public_path__ + "static/media/hht2_ep9_speaking_01.38e06e0f.png";